.image {
  display: inline-block;
  filter: grayscale(0.8);
  max-height: 110px;
  max-width: 110px;
  transition: filter 0.3s ease-in-out;
}

.image:hover {
  filter: none;
}
